module.exports = __webpack_public_path__ + "media/images/daodi-logo-319379973a199fb37ff000cdf00e8080.jpg";